export default __webpack_public_path__ + "static/media/263.7617a5c6.jpg";